import {
  CoachingMilestoneKind,
  CoachingMilestoneView,
} from '@euler/model/coaching-progress';

/** A milestone as the trainee reads it. */
export function milestoneTitle(milestone: CoachingMilestoneView): string {
  const subject = milestone.subject ?? '';
  switch (milestone.kind) {
    case CoachingMilestoneKind.FirstPractice:
      return '完成第一次练习';
    case CoachingMilestoneKind.FirstThreeStars:
      return '第一次拿到 ★★★';
    case CoachingMilestoneKind.FirstThreeStarsAdvanced:
      return '在「高阶」拿到 ★★★';
    case CoachingMilestoneKind.FirstThreeStarsExpert:
      return '在「专家」拿到 ★★★';
    case CoachingMilestoneKind.AreaSixty:
      return `「${subject}」达到 60`;
    case CoachingMilestoneKind.AreaEighty:
      return `「${subject}」达到 80`;
    case CoachingMilestoneKind.CriticalErrorAvoided:
      return `连续三次没再犯：${subject}`;
    case CoachingMilestoneKind.FiveInAWeek:
      return '一周练满 5 次';
    case CoachingMilestoneKind.CaseImproved:
      return `「${subject}」从 ★ 练到 ★★★`;
  }
}

/** Milestones still to earn, with what earns them. */
export const kLockedMilestones: {
  kind: CoachingMilestoneKind;
  condition: string;
}[] = [
  { kind: CoachingMilestoneKind.FirstPractice, condition: '完成第一次练习' },
  {
    kind: CoachingMilestoneKind.FirstThreeStars,
    condition: '第一次拿到 ★★★',
  },
  {
    kind: CoachingMilestoneKind.FirstThreeStarsAdvanced,
    condition: '在「高阶」拿到 ★★★',
  },
  {
    kind: CoachingMilestoneKind.FirstThreeStarsExpert,
    condition: '在「专家」拿到 ★★★',
  },
  { kind: CoachingMilestoneKind.AreaEighty, condition: '任意一项能力达到 80' },
  { kind: CoachingMilestoneKind.FiveInAWeek, condition: '一周练满 5 次' },
  {
    kind: CoachingMilestoneKind.CaseImproved,
    condition: '把同一个场景从 ★ 练到 ★★★',
  },
];
